/**
 * Lazy-loads app-screen HTML fragments via IntersectionObserver.
 *
 * Usage in templates:
 *   <div class="app-screen-lazy" data-screen-url="/blocks/app-screen/ai_chat/">
 *     <div class="animate-pulse bg-gray-100 rounded-2xl" style="aspect-ratio:4/3"></div>
 *   </div>
 */
(function () {
  'use strict';

  function loadScreen(el) {
    var url = el.getAttribute('data-screen-url');
    if (!url) return;

    // Pass current page language to the endpoint so it renders
    // the correct translation (the endpoint lives outside i18n_patterns).
    var lang = document.documentElement.lang || 'de';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    url = url + sep + 'lang=' + lang;

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        el.innerHTML = html;
        // Re-run any inline <script> tags in the fragment
        var scripts = el.querySelectorAll('script');
        scripts.forEach(function (old) {
          var s = document.createElement('script');
          if (old.src) {
            s.src = old.src;
          } else {
            s.textContent = old.textContent;
          }
          old.parentNode.replaceChild(s, old);
        });
      })
      .catch(function () {
        // Silently fail — the placeholder remains visible
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('.app-screen-lazy');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: load all immediately
      els.forEach(loadScreen);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadScreen(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '300px' }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  });
})();
